module.exports = __webpack_public_path__ + "img/fossilImg3.a1b2be3d.jpg";